export const OPEN_CREATE_DOMAIN_MODAL = 'OPEN_CREATE_DOMAIN_MODAL';
export const REFRESH_DOMAIN_VALIDATION = 'REFRESH_DOMAIN_VALIDATION';

export const DOMAIN_STATUS = {
    PARTIAL: 3,
    RUNNING: 4,
};
